import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import PagesHero from "../components/PagesHero";
import FreeOddSection from "../components/FreeOddSection";
import PreviousWinsSection from "../components/PreviewsWinsSection";
import axios from "axios";

function Rollover() {
  const [expertResult, setExpertResult] = useState([]);
  useEffect(() => {
    axios
      .get("/result")
      .then(({ data }) => {
        setExpertResult(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <div>
      <Header />
      <PagesHero page={"Rollover Tips"} />

      <FreeOddSection title={"Rollover"} />

      <PreviousWinsSection results={expertResult} />
      <FooterSection />
    </div>
  );
}

export default Rollover;
